// extracted by mini-css-extract-plugin
export var cookieWrapper = "CookieConsent-module--cookieWrapper--qursF";
export var hidden = "CookieConsent-module--hidden--TrVmG";
export var innerWrapper = "CookieConsent-module--innerWrapper--iH8OH";